export const educationHistory = [
  {
    imageSrc: "/images/gatech.bmp",
    link: "https://omscs.gatech.edu/specialization-interactive-intelligence",
    title: "Georgia Institute of Technology",
    subtitle: "Graduate Studies, Computer Science",
    date: "2018 - 2021",
    description:
      "Completed graduate-level coursework toward a Master’s degree in Computer Science, specializing in Interactive Intelligence, before leaving the program to pursue a professional opportunity.",
    gpa: 3.8,
    suffix: "gt",
    courses: [
      {
        title: "Computer Science",
        courses: [
          { number: "CS 6035", title: "Intro to Information Security", link:"https://omscs.gatech.edu/cs-6035-introduction-information-security" },
          { number: "CS 6250", title: "Computer Networks", link:"https://omscs.gatech.edu/cs-6250-computer-networks" },
          { number: "CS 6262", title: "Network Security", link:"https://omscs.gatech.edu/cs-6262-network-security" },
          { number: "CS 6400", title: "Database Systems Concepts & Design", link:"https://omscs.gatech.edu/cs-6400-database-systems-concepts-and-design" },
          { number: "CS 6601", title: "Artificial Intelligence", link: "https://omscs.gatech.edu/cs-6601-artificial-intelligence" },
        ]
      }
    ],
  },
  {
    imageSrc: "/images/ku.bmp",
    link: "https://eecs.ku.edu/degree-requirements-undergraduate#computer-science",
    title: "University of Kansas",
    subtitle: "Computer Science, B.S.",
    date: "2011 - 2016",
    description: "Additionally earned minors in Business and Mathematics.",
    gpa: 3.9,
    suffix: "ku",
    courses: [
      {
        title: "Computer Science",
        courses: [
          { number: "EECS 140", title: "Intro to Digital Logic Design", link:"" },
          { number: "EECS 169", title: "Programming I: Honors", link:"" },
          { number: "EECS 210", title: "Discrete Structures", link:"" },
          { number: "EECS 268", title: "Programming II", link:"" },
          { number: "EECS 368", title: "Programming Language Paradigms", link:"" },
          { number: "EECS 388", title: "Computer Systems & Assembly Language", link:"" },
          { number: "EECS 448", title: "Software Engineering I", link:"" },
          { number: "EECS 510", title: "Intro to Theory of Computing", link:"" },
          { number: "EECS 560", title: "Data Structures", link:"" },
          { number: "EECS 565", title: "Intro to Information & Computer Security", link:"" },
          { number: "EECS 581", title: "Computer Science Design I", link:"" },
          { number: "EECS 582", title: "Computer Science Design II", link:"" },
          { number: "EECS 645", title: "Computer Architecture", link:"" },
          { number: "EECS 647", title: "Intro to Database Systems", link:"" },
          { number: "EECS 649", title: "Intro to Artificial Intelligence", link:"" },
          { number: "EECS 660", title: "Fundamentals of Computer Algorithms", link:"" },
          { number: "EECS 662", title: "Programming Languages", link:"" },
          { number: "EECS 665", title: "Compiler Construction", link:"" },
          { number: "EECS 672", title: "Intro to Computer Graphics", link:"" },
          { number: "EECS 678", title: "Intro to Operating Systems", link:"" },
        ]
      },
      {
        title: "Math & Statistics",
        courses: [
          { number: "MATH 220", title: "Applied Differential Equations", link:"" },
          { number: "MATH 223", title: "Vector Calculus", link:"" },
          { number: "MATH 290", title: "Elementary Linear Algebra", link:"" },
          { number: "MATH 526", title: "Applied Mathematical Statistics I", link:"" },
          { number: "MATH 590", title: "Linear Algebra", link:"" },
          { number: "MATH 611", title: "Time Series Analysis", link:"" },
          { number: "MATH 699", title: "Directed Reading (Research)", link:"" },
          { number: "MATH 791", title: "Modern Algebra", link:"" },
          { number: "MATH 799", title: "Directed Reading (Research)", link:"" },
        ]
      },
      {
        title: "Business",
        courses: [
          { number: "ACCT 205", title: "Survey of Accounting", link:"" },
          { number: "ECON 104", title: "Introductory Economics", link:"" },
          { number: "FIN 305", title: "Survey of Finance", link:"" },
          { number: "IST 205", title: "Survey of Information Systems", link:"" },
          { number: "MGMT 305", title: "Survey of Management & Leadership", link:"" },
          { number: "MKTG 305", title: "Survey of Marketing", link:"" },
          { number: "SCM 310", title: "Management Science & Operations Management", link:"" },
        ]
      },
      {
        title: "Other",
        courses: [
          { number: "ABSC 100", title: "Intro to Applied Behavioral Science", link:"" },
          { number: "COMS 130", title: "Speaker-Audience Communication", link:"" },
          { number: "ENGL 102", title: "Critical Reading & Writing", link:"" },
          { number: "ENGL 209", title: "Intro to Fiction", link:"" },
          { number: "KOR 508", title: "Advanced Modern Korean II", link:"" },
          { number: "PHSX 212", title: "General Physics II", link:"" },
          { number: "PSYC 104", title: "General Psychology", link:"" },
          { number: "THR 100", title: "Intro to Theatre", link:"" },
          { number: "THR 220", title: "Costume Production", link:"" },
        ]
      }
    ],
  },
];
